export default {
  D: "#00639a",
  E: "#00639a",
  K: "#00639a",
  R: "#00639a",
  H: "#00639a",
};
